/* storybook-check-ignore */
import { FC, useState } from 'react';

import { CONSUMER_URL } from 'components/globals';
import { useTrackProperty } from 'components/marketplace/helpers';
import { TOUR_ACTION_TEXT, TourKind } from 'components/self-tour/hooks/useTouring';

import { useObservability } from 'helpers/observability';

import { FloatingCTA } from './PropertySection/FloatingCTA';
import { TourWithAgentModal } from './PropertySection/TourWithAgentModal';
import { PropertyDetailsType } from './types';

interface FooterCTAProps {
  kind: TourKind;
  property: PropertyDetailsType;
  isVisible?: boolean;
}

export const FooterCTA: FC<FooterCTAProps> = ({ kind, property, isVisible = true }) => {
  const { trackProperty } = useTrackProperty();
  const { trackJourneyEvent } = useObservability();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleCtaClick = () => {
    if (kind === 'selfTour') {
      trackProperty('property-self-tour', 'marketplace-pdp-footer-cta');
      trackJourneyEvent('marketplaceProperty', 'tourBookingStart', {
        addressUuid: property.addressToken,
        placement: 'footer',
      });

      window.open(
        `${CONSUMER_URL}/dashboard/buy/tour?id=${property.addressToken}`,
        '_blank',
        'noopener',
      );
    } else {
      setIsDialogOpen(true);
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <FloatingCTA
        ctaText={TOUR_ACTION_TEXT[kind]}
        onClickCta={handleCtaClick}
        isLiked={property.isLiked}
        onClickReaction={property.onClickReaction}
        variant={kind === 'tourWithAgent' ? 'secondary' : 'primary'}
        isVisible={isVisible}
      />
      {kind === 'tourWithAgent' && (
        <TourWithAgentModal property={property} isOpen={isDialogOpen} onClose={handleClose} />
      )}
    </>
  );
};
